import axios from "axios";
import { BACKEND_URL } from "../constants/Constant";

const BASE_URL = `${BACKEND_URL}/system-messages`;

const getFreeAutoSchedule = async () => {
  try {
    const response = await axios.get(`${BASE_URL}/user-free-auto-schedule`);
    return response.data;
  } catch (error) {
    console.error("Error fetching free auto schedule:", error);
    throw error;
  }
};

export {
  getFreeAutoSchedule,
};